import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';


export const authGuard: CanActivateFn = (route, state) => {
  const cookieService = inject(CookieService);
  const router = inject(Router);

  const userCookie = cookieService.get('user');
  if (userCookie) {
    return true; 
  } else {
    router.navigate(['/auth/login']);
    return false;
  }
};
